export const environment = {
  production: true,
  tenant: "ipko",
  loginToken: "37626b9f-1724-4185-889f-195f24d41306",
  apiServerUrl: `/api-server`,
  firebase: {
    apiKey: "AIzaSyDH6IucWuo-rRAs69sDmlQwx-Od1Hk1ROc",
    authDomain: "angie-iot-prod-d57ba.firebaseapp.com",
    projectId: "angie-iot-prod-d57ba",
    storageBucket: "angie-iot-prod-d57ba.appspot.com",
    messagingSenderId: "512013221922",
    appId: "1:512013221922:web:38444b631b18c2a114ca7b",
    measurementId: "G-2WB5X9TKYP"
  },
  mapTilesAddress: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  sentry: {
    enabled: true,
    environment: 'production',
  }
};
